// extracted by mini-css-extract-plugin
module.exports = {"downloadBadges":"styles_downloadBadges__30uv7","icon":"styles_icon__2iHYG"};